import React, { FC, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import dayjs, { Dayjs } from 'dayjs';

import { PageHeader } from 'components/PageHeader';
import { FilterBlock } from 'components/FilterBlock';
import { Extra } from 'features/Analytics/AnalyticsApartmentStatus';

import { TITLES, ROUTES } from 'consts';
import { useSearchParams } from 'hooks';

import { FilterKeys, filterConfig } from './const';
import { Flex } from '@10d/tend-ui/grid';

export const AnalyticsApartmentStatus: FC = () => {
  const { query } = useSearchParams<string>();

  const filterValue = useMemo(() => {
    const { [FilterKeys.Start]: start, [FilterKeys.End]: end } = query;

    const queryValue: Record<string, string | string[] | Dayjs[] | undefined> = {};

    Object.values(FilterKeys).forEach(filterKey => {
      const value = query[filterKey];

      if (filterKey === FilterKeys.Period) {
        queryValue[filterKey] =
          start && end
            ? [dayjs(start as string, 'DD-MM-YYYY'), dayjs(end as string, 'DD-MM-YYYY')]
            : undefined;
      } else if (value) {
        const isArray = Array.isArray(value);

        queryValue[filterKey] = isArray ? value.map(item => String(item)) : String(value);
      } else {
        // Необходимо для корректно работы кнопки "Сбросить все"
        queryValue[filterKey] = undefined;
      }
    });

    return queryValue;
  }, [query]);

  return (
    <>
      <Helmet>
        <title>{`Home - ${TITLES[ROUTES.ANALYTICS.ROOT]}: ${
          TITLES[ROUTES.ANALYTICS.APARTMENT_STATUS]
        }}`}</title>
      </Helmet>

      <PageHeader
        title={`${TITLES[ROUTES.ANALYTICS.ROOT]}: ${TITLES[ROUTES.ANALYTICS.APARTMENT_STATUS]}`}
      />

      <FilterBlock value={filterValue} filters={filterConfig} isShowClearButton />

      <Flex justify='center' margin={'160px 0 0 0'}>
        <Extra />
      </Flex>
    </>
  );
};
